import { Table, TableBody, TableCell, TableRow } from '@mui/material';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { Popup } from 'react-map-gl';
import EntitySelectionPopupOption from './EntitySelectionPopupOption';
import Styles from './MapComponents.scss';

const EntitySelectionPopup = (props) => {
    const {
        onClose,
        onSelectEntityVersion,
        entityVersionsByClientId,
        visibleFolders,
        coordinates,
    } = props;

    const [options, setOptions] = useState([]);
    const minWidth = '200px';

    const handleSelection = (entityVersion) => {
        onSelectEntityVersion(entityVersion.properties.entity_version_id);
        onClose();
    };

    useEffect(() => {
        const output = [];
        for (const prop in entityVersionsByClientId) {
            const groupedEntities = entityVersionsByClientId[prop];
            const opts = groupedEntities.map((ev, i) => {
                const wp = visibleFolders.find(
                    (wp) => ev.properties.folder_id === wp.folder_id
                );
                return (
                    <EntitySelectionPopupOption
                        folderName={wp.folder_name}
                        onClick={() => handleSelection(ev)}
                        key={`popupOpt${wp.folder_id}${i}`}
                    />
                );
            });

            output.push(
                <div className={Styles.espGroup} key={`tbl${prop}`}>
                    <Table size="small">
                        <TableBody>
                            <TableRow>
                                <TableCell>
                                    <span className={Styles.espTitleLbl}>
                                        Pole{' '}
                                        {
                                            groupedEntities[0].properties
                                                .client_id
                                        }
                                    </span>
                                </TableCell>
                            </TableRow>
                            {opts}
                        </TableBody>
                    </Table>
                </div>
            );
        }

        setOptions(output);
    }, [entityVersionsByClientId]);

    return (
        <Popup
            longitude={coordinates[0]}
            latitude={coordinates[1]}
            onClose={onClose}
            style={{
                zIndex: Styles.popupZIndex,
                minWidth: minWidth,
                padding: 0,
            }}
            maxWidth={'auto'}
        >
            {options}
        </Popup>
    );
};

EntitySelectionPopup.propTypes = {
    onClose: PropTypes.func,
    onSelectEntityVersion: PropTypes.func,
    entityVersionsByClientId: PropTypes.object,
    visibleFolders: PropTypes.array,
    poleId: PropTypes.string,
    coordinates: PropTypes.array,
};
export default EntitySelectionPopup;
